import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import C from '../../constants/routes';
import Style from './buttons.scss';
import cx from 'classnames';
import { PrimaryButton, ChatbotButton } from '../utils/Styled/buttons';
import C_SC from '../../constants/serviceCatalog';

class Buttons extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.showAIButton !== prevProps.showAIButton && this.props.showAIButton) {
      this.props.actions.getToolboxItemsByID(C_SC.SYSAI_CHATBOT_SC_ID);
    }
  }

  render() {
    const sysAIChatbotSC = this.props.scItem;
    const chatbotBtn = sysAIChatbotSC ? (
      <LinkContainer to={{ pathname: sysAIChatbotSC.targetUrl }}>
        <ChatbotButton bsStyle="primary">
          <img
            src={sysAIChatbotSC.iconPath}
            alt={`${sysAIChatbotSC.name} Image`}
            className={Style.buttonIcon}
          />
          {sysAIChatbotSC.name}
        </ChatbotButton>
      </LinkContainer>
    ) : (
      false
    );
    const incidentBtn = (
      <LinkContainer to={{ pathname: C.INCIDENT_PATH }}>
        <PrimaryButton bsStyle="primary">
          <span
            className={cx('iconIssue', Style.buttonIcon, 'iconIssueWhite')}
          ></span>
          {this.props.intlObject['ssp.toolbar.SubmitIncident']}
        </PrimaryButton>
      </LinkContainer>
    );
    const srBtn = (
      <LinkContainer to={{ pathname: C.SR_PATH }}>
        <PrimaryButton bsStyle="primary">
          <span
            className={cx('iconIssue', Style.buttonIcon, 'iconRequestWhite')}
          ></span>
          {this.props.intlObject['ssp.toolbar.SubmitRequest']}
        </PrimaryButton>
      </LinkContainer>
    );
    return (
      <div role="form" className={cx('toolbarButtons')}>
        {chatbotBtn}
        {this.props.showIncidentButton ? incidentBtn : ''}
        {this.props.showSrButton ? srBtn : ''}
      </div>
    );
  }
}

Buttons.propTypes = {
  showIncidentButton: PropTypes.bool.isRequired,
  showSrButton: PropTypes.bool.isRequired,
  intlObject: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  scItem: PropTypes.object,
  showAIButton: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    scItem: state.serviceCatalog.getIn([C_SC.SYSAI_CHATBOT_CALALOG_ITEM])
  };
}

export default connect(mapStateToProps)(Buttons);



// WEBPACK FOOTER //
// ./components/Toolbar/buttons.js